<template>
    <div class="list">
		<div class="item" v-for="(item,i) in list" :key="i">
			<router-link :to="`/news-detail-${item.id}`" >
				<el-image fit="cover" class="image" :src="$img(item.image)" @error="item.image = defaultGoodsImage" />
				<div class="con">
					<h2>{{item.title}}</h2>
					<desc-text class="text" :text="item.content" :textStyle="{WebkitLineClamp:3}"></desc-text>
					<!-- <div class="desc">{{item.datetime.date}}</div> -->
					<div class="tags">
						<span>{{item.datetime.date}}</span>
					</div>
				</div>
			</router-link>
		</div>
    </div>
</template>

<script>
    import { mapGetters } from "vuex"
	import {
		newsList,
		newsCat
	} from "@/api/cms/news";
	import SubTitle from "@/components/SubTitle"
	import DescText from "@/components/DescText"
	
    export default {
        name: "list1",
        components: {
			SubTitle,
			DescText
        },
        props: {
            config: {
                type: Object,
                // required: true
            },
			list: {
                type: Array,
                required: true
            }
        },
        data() {
            return {
            }
        },
        created() {
        },
        computed: {
            ...mapGetters(["defaultGoodsImage"])
        },
        methods: {
            
        },
        watch: {
            config: {
                handler: (e)=>{
                },
                immediate: true,
                deep: true
            }
        }
    }
</script>

<style lang="scss" scoped>
.list{
	.item{
		display: block;
		overflow: hidden;
		margin-bottom: 15px;
		.image{
			width: 22%;
			float: left;
			height: 140px;
		}
		.con{
			width: 78%;
			float: left;
			padding: 0  0 0 15px;
			overflow: hidden;
			box-sizing: border-box;
			h2{
				// padding: 5px;
				// width: 100%;
				// display: block;
				overflow: hidden;
				text-overflow:ellipsis;
				white-space: nowrap;
				// line-height: 50px;
			}
			.text{
				height: 75px;
			}
			.tags{
				span{
					float: right;
				}
			}
		}
	}
}
</style>
